import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Switch, Route } from 'react-router-dom'
import PrivateRoute from 'components/routes/Private'
import AllGlobalRolesRoute from 'components/routes/AllGlobalRoles'
import AnyGlobalRolesRoute from 'components/routes/AnyGlobalRoles'
import AnyRolesRoute from 'components/routes/AnyRoles'
import NoGlobalRolesRoute from 'components/routes/NoGlobalRoles'
import { lifecycle, compose } from 'recompose'
import withRoles from 'containers/Role/Project/index'

import {
  GLOBAL_ROLES,
  PRODUCT_ROLES,
  PROJECT_ROLES,
  ROUTE_ROLES,
} from 'containers/Role/constants'

import {
  enableRoleStatus,
} from 'containers/Role/Project/actions'

import {
  projectIdSelector,
} from 'containers/Role/Project/selectors'

// Project Creation
import ProjectView from 'containers/Project/View/index'
import ProjectUpdate from 'containers/Project/Update/index'
import ProjectUpdateReview from 'containers/Project/UpdateReview/index'
import ProjectCreate from 'containers/Project/Create/index'
import ProjectOverview from 'containers/Project/Overview/index'
import ProjectReview from 'containers/Project/Review/index'
import ProjectSearch from 'containers/Project/Search/index'
import ProjectElasticSearch from 'containers/Project/ElasticSearch/index'

//Workflow Approvals
import ApprovalPage from 'containers/Approval/ApprovalPage/index'

const mapStateToProps = (state) => {
  return {
    projectId: projectIdSelector(state)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    enableStatus: () => dispatch(enableRoleStatus())
  }
}
const enhance = compose(
  withRoles,
  connect(mapStateToProps, mapDispatchToProps),
)

const ProjectIdRoutes = props => {
  return (
    <Switch>
      <AnyRolesRoute
        exact
        path='/project/:id/view'
        component={ProjectView}
        roles={[
          GLOBAL_ROLES.LIMITED_ACCESS,
          GLOBAL_ROLES.FULL_ACCESS,
          GLOBAL_ROLES.ADMIN_ACCESS,
          GLOBAL_ROLES.CLIENT_ACCESS,
        ]}
      />
      <AnyRolesRoute
        exact
        path='/project/:id/review'
        component={ProjectUpdateReview}
        roles={[
          PRODUCT_ROLES.PRODUCT_APPLICATIONS_ENGINEER,
          PROJECT_ROLES.CUSTOMER_PROGRAM_MANAGER,
          PROJECT_ROLES.ACCOUNT_APPLICATIONS_ENGINEER,
          PROJECT_ROLES.APPLICATIONS_ENGINEERING_MANAGER,
          PRODUCT_ROLES.PRODUCT_APPLICATIONS_ENGINEER,
          GLOBAL_ROLES.ADMIN_ACCESS,
          GLOBAL_ROLES.CLIENT_ACCESS,
        ]}
      />
      <AnyRolesRoute
        exact
        path='/project/:id/update'
        component={ProjectUpdate}
        roles={[
          PRODUCT_ROLES.PRODUCT_APPLICATIONS_ENGINEER,
          PROJECT_ROLES.CUSTOMER_PROGRAM_MANAGER,
          PROJECT_ROLES.ACCOUNT_APPLICATIONS_ENGINEER,
          PROJECT_ROLES.APPLICATIONS_ENGINEERING_MANAGER,
          PRODUCT_ROLES.PRODUCT_APPLICATIONS_ENGINEER,
          GLOBAL_ROLES.ADMIN_ACCESS,
          GLOBAL_ROLES.CLIENT_ACCESS,
        ]}
      />
    </Switch>
  )
}

const EnhancedProjectIdRoutes = enhance(ProjectIdRoutes)

const ProjectRoutes = props => {
  return (
    <Switch>
      <AllGlobalRolesRoute exact path='/project/list' roles={[GLOBAL_ROLES.CLIENT_ACCESS]} component={ProjectSearch}/>
      <NoGlobalRolesRoute exact path='/project/search' roles={[GLOBAL_ROLES.CLIENT_ACCESS]} component={ProjectElasticSearch}/>
      <AnyGlobalRolesRoute exact path='/project/create' roles={[ROUTE_ROLES.PROJECT_CREATE]} component={ProjectCreate}/>
      <PrivateRoute exact path='/project/overview' component={ProjectOverview}/>
      <PrivateRoute exact path='/project/review' component={ProjectReview}/>
      <NoGlobalRolesRoute path='/project/approvals' roles={[GLOBAL_ROLES.CLIENT_ACCESS]} component={ApprovalPage}/>
      <PrivateRoute path='/project/:id' component={EnhancedProjectIdRoutes}/>
    </Switch>
  )
}

export default ProjectRoutes
